import { useSelector } from 'react-redux'

import { formatNameWithCode } from 'utils/formatters'
import { fromGlobalId } from 'utils/transformations/graphql'

import {
  getAccountId,
  getAccountProfileName,
} from 'store/currentUser/selectors'

import {
  AccountOption,
  OptionWrapper,
  SectionTitle,
} from '../../retailerAccountsDropdown.ui'
import AccountDropdownOption from '../AccountDropdownOption/AccountDropdownOption'
import CurrentAccountSettings from '../CurrentAccountSettings/CurrentAccountSettings'
import PrimaryAccount from '../PrimaryAccount/PrimaryAccount'
import { LiteRetailerAccountsType } from 'features/Navbar/NavbarLiteRetailer/NavbarLiteRetailer.queries'
import { RetailAccountsDropdownIds } from 'features/Navbar/NavbarRevamp/navbarRevamp.ids'
import { GrapheneAccount } from 'features/Navbar/NavbarRevamp/navbarRevamp.types'

const CurrentAccountSection = ({
  accounts,
  userAccounts,
}: {
  accounts: LiteRetailerAccountsType[]
  userAccounts: GrapheneAccount[]
}) => {
  const accountId = useSelector(getAccountId)
  const accountName = useSelector(getAccountProfileName)
  const currentAccount = accounts.find(
    (account) => String(accountId) === fromGlobalId(account.id)?.id,
  )
  const currentAccountTestId = `${RetailAccountsDropdownIds.AccountsOption}__${accountId}`
  return (
    <OptionWrapper data-testid={RetailAccountsDropdownIds.CurrentAccount}>
      <SectionTitle>Current Account</SectionTitle>
      <AccountOption
        key={currentAccountTestId}
        data-testid={currentAccountTestId}
      >
        <AccountDropdownOption
          accountName={formatNameWithCode(accountName, accountId)}
          hideVisibilityIcon={!currentAccount}
          connectedAccounts={currentAccount?.connectedAccounts}
          privacy={!!currentAccount?.privacy}
          createdAt={currentAccount?.createdAt?.toString() || ''}
          isPrimary={!!currentAccount?.isPrimary}
          isCurrentAccount
          createdBy={
            currentAccount?.accountCreationSource?.requestedByAccount &&
            currentAccount?.accountCreationSource?.requestedByAccount?.id ===
              currentAccount?.id
              ? 'you'
              : currentAccount?.accountCreationSource?.requestedByAccount?.name
          }
        />
      </AccountOption>
      <PrimaryAccount
        accounts={accounts}
        userAccounts={userAccounts}
        checkboxId={RetailAccountsDropdownIds.PrimaryAccountCheckbox}
        displayModal
      />
      <CurrentAccountSettings />
    </OptionWrapper>
  )
}

export default CurrentAccountSection
